import { useEffect, useRef } from "react";

export const usePrevious = value => {
  const ref = useRef();
  useEffect(() => {
    ref.current = value; //assign the value of ref to the argument
  }, [value]); //this code will run when the value of 'value' changes
  return ref.current; //in the end, return the current ref value.
};

/**
 * https://codefrontend.com/resize-observer-react/
 *
 * @param {*} ref
 * @param {*} callback
 * @returns ref
 */
export const useResizeObserver = ({ ref, onResize }) => {
  useEffect(() => {
    const element = ref?.current;

    if (!element) {
      return;
    }

    if (!hasResizeObserver()) {
      window.addEventListener("resize", onResize, false);
      return () => {
        window.removeEventListener("resize", onResize, false);
      };
    }

    const resizeObserverInstance = new window.ResizeObserver(entries => {
      if (!entries.length) {
        return;
      }
      onResize(element);
    });

    resizeObserverInstance.observe(element);

    return () => {
      if (element) {
        resizeObserverInstance.unobserve(element);
      }
    };
  }, [onResize, ref]);

  return ref;
};

function hasResizeObserver() {
  return typeof window.ResizeObserver !== "undefined";
}
